__turbopack_context__.v({
  "caret": "NavigationSubMenu-module-scss-module__qWOTwG__caret",
  "categoriesColumn": "NavigationSubMenu-module-scss-module__qWOTwG__categoriesColumn",
  "categoriesLabel": "NavigationSubMenu-module-scss-module__qWOTwG__categoriesLabel",
  "dropdownButton": "NavigationSubMenu-module-scss-module__qWOTwG__dropdownButton",
  "menuItem": "NavigationSubMenu-module-scss-module__qWOTwG__menuItem",
  "navLink": "NavigationSubMenu-module-scss-module__qWOTwG__navLink",
  "open": "NavigationSubMenu-module-scss-module__qWOTwG__open",
  "rotated": "NavigationSubMenu-module-scss-module__qWOTwG__rotated",
  "subMenuContent": "NavigationSubMenu-module-scss-module__qWOTwG__subMenuContent",
  "subMenuPanel": "NavigationSubMenu-module-scss-module__qWOTwG__subMenuPanel",
});
